export const breadcrumb = {
  title: 'Базы данных',

  database: {
    index: 'Список баз данных',
    import: 'Импорт',
    recipient: {
      create: 'Создание контакта',
      edit: 'Редактирование контакта'
    }
  },
  group: {
    index: 'Группы'
  }
};
